import i18n from 'localization/i18n';

export const MODAL_TYPES = {
  REDIRECT: 'redirect',
  CONTACT_NOTICE: 'contactNotice',
  UPLOAD_WARNING: 'uploadWarning',
  CANCEL: 'cancelForm',
};

export const getAssetFormGlobalModalProps = (
  type: string,
  isAllSelectedBeneContacted?: boolean
) => {
  let title,
    description,
    primaryButtonText,
    secondaryButtonText = '';
  switch (type) {
    case MODAL_TYPES.CANCEL:
    case MODAL_TYPES.REDIRECT:
      title = i18n.t('plan:redirection_modal_warning');
      primaryButtonText = i18n.t('common:continue');
      break;
    case MODAL_TYPES.CONTACT_NOTICE:
      title = i18n.t(
        `plan:${
          isAllSelectedBeneContacted
            ? 'bene_noticed_already_modal_title'
            : 'bene_will_notice_modal_title'
        }`
      );
      description = i18n.t(
        `plan:${
          isAllSelectedBeneContacted
            ? 'bene_noticed_already_modal_description'
            : 'bene_will_notice_modal_description'
        }`
      );
      primaryButtonText = i18n.t('common:yes_cap');
      break;
    default:
      title = i18n.t('plan:upload_warning_modal_title');
      description = [
        i18n.t('plan:upload_warning_modal_description_1'),
        i18n.t('plan:upload_warning_modal_description_2'),
      ];
      primaryButtonText = i18n.t('plan:upload_warning_modal_upload_btn');
      secondaryButtonText = i18n.t('plan:upload_warning_modal_save_anyway_btn');
  }
  return { title, description, primaryButtonText, secondaryButtonText };
};
